import qs from 'qs';
import {v} from './main.js';

const axios = require('axios').default;
const baseDomain = 'https://www.goldenwin.com.hk';
const downDownloadDomain = baseDomain + '/form/';
const domain = baseDomain + '/api';
let token = localStorage.getItem('token');

const instance = axios.create({
  baseURL: domain,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded',
  }
});
const post = (api, params = {}) => {
  return instance.post(domain + api, qs.stringify(params))
    .then(function (response = {}) {
      if (response.data && response.data.status === 200) {
        return response.data;
      } else if(response.data.status === 403) {
        localStorage.removeItem('token');
        token = null;
        v.$router.push('/signin');
      } else {
        return Promise.reject(response.data || {});
      }
    });
};
const get = (api, params = {}) => {
  return instance.get(domain + api + (Object.keys(params).length > 0 ? ('?' + qs.stringify(params)) : ''))
    .then(function (response = {}) {
      if (response.data && response.data.status === 200) {
        return response.data;
      } else if(response.data.status === 403) {
        v.$router.push('/signin');
      } else {
        return Promise.reject(response.data || {});
      }
    });
};

const login = (params) => {
  return post('/login', params)
    .then(function (response) {
      token = response.data.token;
      localStorage.setItem('token', response.data.token);
    });
};
const register = (params) => {
  return post('/register', params);
};
const findPassword = (params) => {
  return post('/change/pwd', params);
};
const getCode = (params) => {
  return post('/get/code', params);
};
// 今日可面試接口
const getTodayAvailiableList = () => {
  const params = {};
  if (token)
    params.token = token;
  return get('/interview/member', params)
  .then(function (response) {
    return response.data;
  })
  .catch(function () {
    return [];
  });
};
const getList = (params) => {
  const initParams = {};
  if (token)
    initParams.token = token;
  return get('/member/list', Object.assign(initParams, params));
};
const getSearchText = () => {
  const params = {};
  if (token)
    params.token = token;
  return get('/search/text', params);
};
const getCacheTable = (params) => {
	if(token)
		params.token = token;
	return get('/cache/table', params);
};
const postCacheTable = (params) => {
	if(token)
		params.token = token;
	return post('/post/cache/table', params);
};
// 收藏列表
const getFavoritesList = () => {
    const params = {};
    if (token)
      params.token = token;
    return get('/favorite/list', params)
    .then(function (response) {
      return response.data;
    })
    .catch(function () {
      return [];
    });
};
const getInterviewApplyHistoryForm = () => {
    const params = {};
    if (token)
      params.token = token;
    return get('/interview/filling-info', params)
    .then(function (response) {
      return response.data;
    })
    .catch(function () {
      return [];
    });
};
const getInterviewsList = (params) => {
    const initParams = {};
    if (token)
    initParams.token = token;
    return get('/interview/list', Object.assign(initParams, params))
    .then(function (response) {
      return response.data;
    })
    .catch(function () {
      return [];
    });
};
const getInterviewsHistoryList = (params) => {
	const initParams = {};
	if (token)
	initParams.token = token;
	return get('/interview/history-list', Object.assign(initParams, params))
	.then(function (response) {
	  return response.data;
	})
	.catch(function () {
	  return [];
	});
};
const removeInterviewHistory = (params) => {
    const initParams = {};
    if (token)
      initParams.token = token;
    return post('/interview/history-remove', Object.assign(initParams, params));
};
const interviewSetConfirmInfo = (params) => {
    const initParams = {};
    if (token)
      initParams.token = token;
    return post('/interview/set-confirm', Object.assign(initParams, params));
};
const interviewGetConfirmInfo = (params) => {
    const initParams = {};
    if (token)
    initParams.token = token;
    return get('/interview/get-confirm', Object.assign(initParams, params))
    .then(function (response) {
      return response.data;
    })
    .catch(function () {
      return [];
    });
};
const markFavorite = (params) => {
    const initParams = {};
    if (token)
      initParams.token = token;
    return post('/favorite/add', Object.assign(initParams, params));
};
const markInterview = (params) => {
	const initParams = {};
	if (token)
	  initParams.token = token;
	return post('/interview/add', Object.assign(initParams, params));
};
const submitApplyInterview = (params) => {
	const initParams = {};
	if(token)
		initParams.token = token;
	return post('/interview/apply-submit',Object.assign(initParams,params));
};
const getDetail = (params) => {
  const initParams = {};
  if (token)
    initParams.token = token;
  return get('/member/detail', Object.assign(initParams, params));
};
const addContract = (params) => {
  const initParams = {};
  if (token)
    initParams.token = token;
  return post('/contract/add', Object.assign(initParams, params));
}
const newAddContract = (params) => {
  const initParams = {};
  if (token)
    initParams.token = token;
  return post('/ncontract/add', Object.assign(initParams, params));
}
const pay = (params) => {
  const initParams = {};
  if (token)
    initParams.token = token;
  const url = baseDomain + '/pay?' + qs.stringify(Object.assign(initParams, params));
  window.location.href = url;
  // return Promise.resolve(url);
  // window.open(baseDomain + '/pay?' + qs.stringify(Object.assign(initParams, params)));
  // const urlPromise = new Promise((res, rej) => {res(url);});
  // var windowReference = window.open();
  // urlPromise.then(function(url) {
      // windowReference.location.href = url;
  // });
}
const getPay = (params) => {
  const initParams = {};
  if (token)
    initParams.token = token;
  const url = baseDomain + '/pay?' + qs.stringify(Object.assign(initParams, params));
  // return window.location.href = url;
  return url;
}
const my = (params) => {
  const initParams = {};
  if (token)
    initParams.token = token;
  return get('/my', Object.assign(initParams, params));
}
const editMy = (params) => {
  const initParams = {};
  if (token)
    initParams.token = token;
  return post('/my/edit', Object.assign(initParams, params));
}

const resetInterviewAt = (params) => {
  const initParams = {};
  if (token)
    initParams.token = token;
  return post('/interviewat/reset', Object.assign(initParams, params));
}
const leaveMessage = (params) => {
  const initParams = {};
  if (token)
    initParams.token = token;
  return post('/message/board', Object.assign(initParams, params));
}
const renew = (params) => {
  const initParams = {};
  if (token)
    initParams.token = token;
  return post('/online/renew', Object.assign(initParams, params));
}
const checkPay = (params) => {
  const initParams = {};
  if (token)
    initParams.token = token;
  return get('/order/query', Object.assign(initParams, params));
};
const getOrderList = (params) => {
  const initParams = {};
  if (token)
    initParams.token = token;
  return get('/order/list', Object.assign(initParams, params));
};
const getProcessList = (params) => {
  const initParams = {};
  if (token)
    initParams.token = token;
  return get('/process/list', Object.assign(initParams, params));
};
const getProcessDetail = (params) => {
  const initParams = {};
  if (token)
    initParams.token = token;
  return get('/process/detail', Object.assign(initParams, params));
};
const getPic = (params) => {
  const initParams = {};
  if (token)
    initParams.token = token;
  return get('/bg/picture', Object.assign(initParams, params));
};
const getVideo = (params) => {
  const initParams = {};
  if (token)
    initParams.token = token;
  return get('/search/top/video', Object.assign(initParams, params));
};
const hasToken = () => {
  return !!localStorage.getItem('token');
};
const logout = () => {
  if(token) {
    post('/loginout', {token});
    localStorage.removeItem('token');
    token = null;
  }
};
export default {
  domain,
  insurance: downDownloadDomain + 'insurance.pdf',
  holidayen: downDownloadDomain + 'holiday-English.pdf',
  holidayzh: downDownloadDomain + 'holiday-Chinese.pdf',
  id4: downDownloadDomain + 'FORM3_id407e_NotificationOfTermination.pdf',
  id9: downDownloadDomain + 'ID988A.pdf',
  payroll: downDownloadDomain + 'FORM2_Salary_Receipt.pdf',
  labor: downDownloadDomain + 'FORM6_ Labour_CalculationForm_for_Domestic_Helper.pdf',
  url7: downDownloadDomain + 'FORM7_Labour.pdf',
  login,
  register,
  findPassword,
  getCode, // 獲取短信驗證碼
  getFavoritesList,
  getInterviewApplyHistoryForm,
  getInterviewsList,
  interviewSetConfirmInfo,
  interviewGetConfirmInfo,
  getInterviewsHistoryList,
  removeInterviewHistory,
  markFavorite,
  markInterview,
  submitApplyInterview,
  getTodayAvailiableList,
  getList,
  getDetail,
  addContract,
  newAddContract,
  pay,
  getPay,
  my,
  editMy,
  leaveMessage,
  checkPay,
  renew,
  hasToken,
  logout,
  getSearchText,
  getPic,
  getVideo,
  getOrderList,
  getProcessList,
  getProcessDetail,
  getCacheTable,
  postCacheTable,
  resetInterviewAt
};